import styled from 'styled-components';
import { UptimeBox } from '@uptime/uptime-component';

export const StyledAppContainer = styled(UptimeBox)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .notification-container{
    top: 50px;
    .title{
      color: ${({ theme }) => `${theme.uptimeColors.grayScales.white}`};
    }
  }
`;

export const StyledContentWrapper = styled(UptimeBox)`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100vw;

  & > div {
    flex: 1;
  }
`;

export const StyledBody = styled(UptimeBox)`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media print {
    overflow: visible !important;
    div:first-child {
      overflow: visible !important;
    }
  }
`;